var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#1F286B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3425 36.955C43.7182 37.1429 44 37.6125 44 38.0352C44 38.0822 44 38.1761 44 38.2701L42.8728 43.1546C42.7789 43.6243 42.2622 44 41.7926 44C29.7221 44 20 34.2779 20 22.2074C20 21.7378 20.3757 21.2211 20.8454 21.1272L25.7299 20C25.8239 20 25.9178 20 25.9648 20C26.3875 20 26.8571 20.2818 27.045 20.6575L29.2994 25.9178C29.3464 26.0587 29.3933 26.2466 29.3933 26.3405C29.3933 26.6693 29.2055 27.045 28.9706 27.2329L26.1057 29.5812C27.5616 32.681 31.319 36.3914 34.4188 37.8943L36.7671 35.0294C36.955 34.7945 37.3307 34.6067 37.6125 34.6067C37.7534 34.6067 37.9413 34.6536 38.0822 34.7006L43.3425 36.955Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneLogo);
export default __webpack_public_path__ + "static/media/phone-logo.e6f54c66.svg";
export { ForwardRef as ReactComponent };